export const LABEL_UNDERGRADUATE = "undergraduate";
export const LABEL_GRADUATE = "graduate";
export const LABEL_FALL_TERM = "fall";
export const LABEL_ARIZONA_RESIDENT = "Arizona resident";
